import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useMediaQuery } from "@mui/material";
import LaddaButton from "../../buttons/laddaButton";
import { InventoryFeedback } from "./validationLayout/inventoryFB";

const MassiveUploadFeedBack = ({
  open,
  handleClose,
  title,
  actions,
  width,        // opcional
  maxWidth,     // opcional
  data,
  validationSchema
}) => {
  const isSmall = useMediaQuery("(max-width:590px)");
  const section = validationSchema?.section?.toLowerCase?.();

  const renderContent = () => {
    switch (section) {
      case "inventory":
        return <InventoryFeedback data={data} />;
      default:
        return (
          <div style={{ padding: 8 }}>
            <h4 style={{ margin: "0 0 8px" }}>
              {validationSchema?.title || "Resumen de validación"}
            </h4>
            <p style={{ margin: 0, opacity: 0.8 }}>
              No hay vista registrada para la sección{" "}
              <strong>{validationSchema?.section || "(desconocida)"}</strong>.
            </p>
            <pre
              style={{
                marginTop: 12,
                maxHeight: 280,
                overflow: "auto",
                background: "#0b0b0b0d",
                padding: 12,
                borderRadius: 8
              }}
            >
              {JSON.stringify(data, null, 2)}
            </pre>
          </div>
        );
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      fullScreen={isSmall}
      fullWidth
      maxWidth={maxWidth || "md"}
      PaperProps={{
        sx: {
          ...(width ? { width } : {}),
          ...(isSmall ? { m: 1 } : {})
        }
      }}
    >
      {(title || validationSchema?.title) && (
        <DialogTitle id="modal-title">
          <span className="gm-title">{title || validationSchema?.title}</span>
        </DialogTitle>
      )}

      <DialogContent sx={{ pt: 1.25 }}>{renderContent()}</DialogContent>

      <DialogActions>
        {actions ? (
          actions
        ) : (
          <LaddaButton variant="contained" onClick={handleClose}>
            <div className="HContainer align-center">
              <p className="button_text">Cerrar</p>
            </div>
          </LaddaButton>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default MassiveUploadFeedBack;
